export default {
  adicionarAlerta (state, alerta) {
    state.listaAlertas.push(alerta)
  }
}
